import { css } from '@emotion/css';
import { Color } from 'utils/variables'

export const wrap = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const item = css`
  width: calc((100% - 9px)/10);
  height: 29px;
  background: ${Color.LightGrey};
  box-sizing: border-box;
  &:first-child {
    border-radius: 4px 0px 0px 4px;
  }
  &:last-child {
    border-radius: 0px 4px 4px 0px;
  }
`;